<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          :config-module="isDialog ? '119211' : '119210'"
          :expand-adv="true"
          :show-simple="false"
          :custom-search-items="customSearchItems"
          @advSearchItemCallBack="queryHandler"
        >
          <template v-if="!isDialog" slot="operations">
            <el-button v-if="$checkPermission(['button_InvoicePool_delete'])" type="danger" @click="deletes">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            <el-button v-if="$checkPermission(['button_InvoicePool_getInvoice'])" type="primary" @click="getInvoice">{{ $t('CargoMsg.Cargo_GetInvoice') }}</el-button>
            <el-button v-if="$checkPermission(['button_ACInvoice_receiptAssociation'])" type="primary" @click="collectionAssociation">{{ $t('CargoMsg.Cargo_InvoiceAssociation') }}</el-button>
          </template>
        </search-item>
        <div style="flex-grow: 1;min-height: 350px;">
          <cargo-ag-grid-wrapper
            :config-module="isDialog ? '2025080402' : '2025080401'"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="min-height: 350px;height: 100%"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            :config-module="isDialog ? '2025080402' : '2025080401'"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="fetchDataByPage"
          />
        </div>
      </div>
      <!--加入费用-->
      <collection-association-charge-dialog
        v-if="collectionAssociationChargeDialog.visible"
        :visible.sync="collectionAssociationChargeDialog.visible"
        :search-item-module="collectionAssociationChargeDialog.searchItemModule"
        :default-conditions="collectionAssociationChargeDialog.addChargeCondition"
        @addChargeCallBackEvent="addChargeCallBack"
      />
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { callInvoicePoolJob, deleteInvoicePool, queryInvoicePool } from '@/api/act/invoicePool'
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { ApiCacheManage, multiply } from '@/utils/commonUtil'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import collectionAssociationChargeDialog from '@/components/Cargo/Act/collectionAssociationChargeDialog.vue'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { cache } from '@/utils/cacheManager'
import { generateInvoiceFaster, generateInvoiceForPool, getNotInvoiceCharges } from '@/api/clearing/invoice'
import { queryChargePushRecord } from '@/api/clearing/charge'
import { queryInvoiceGoodsName } from '@/api/clearing/invoiceGoodsName'
import {
  INVOICE_CATEGORY_ELECTRONIC_INVOICE,
  INVOICE_CATEGORY_PAPER_INVOICE, INVOICE_TYPE_NORMAL_FEI,
  INVOICE_TYPE_VAT, INVOICE_TYPE_VAT_DEDICATED, INVOICE_TYPE_VAT_FEI,
  INVOICE_TYPES_FEI
} from '@/class/cargo/model/parameters/InvoiceConstant'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'InvoicePoolCommon',
  components: { collectionAssociationChargeDialog, cargoAgGridWrapper, searchItem },
  props: {
    sellerTaxNameDefaultValue: { type: String, default: '' }, // 销方名称 高级查询 默认值
    isDialog: { type: Boolean, default: false },
    // 收票关联场景开启：高级查询"有发票附件"锁定为"是"（文件未同步的票选了也拿不到票面PDF）
    defaultHasAttachment: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      TYPE_NAMES,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        onRowClicked: event => { this.selectedRow = event.data },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceNo'),
          field: 'invoiceNo',
          colId: 'invoiceNo',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvoiceTime'),
          field: 'invoiceTime',
          colId: 'invoiceTime',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SellerName'),
          field: 'sellerTaxName',
          colId: 'sellerTaxName',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_SellerTaxNumber'),
          field: 'sellerTaxNo',
          colId: 'sellerTaxNo',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_BuyerName'),
          field: 'payerName',
          colId: 'payerName',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_BuyerTaxNumber'),
          field: 'payerTaxNo',
          colId: 'payerTaxNo',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaxExcludedPrice'),
          field: 'exTaxAmount',
          colId: 'exTaxAmount',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaxAmount'),
          field: 'taxAmount',
          colId: 'taxAmount',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaxRate'),
          field: 'taxRate',
          colId: 'taxRate',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaxIncludedPrice'),
          field: 'totalAmount',
          colId: 'totalAmount',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_BoundInvoiceOrNot'),
          field: 'invoiceUuid',
          colId: 'invoiceUuid',
          width: 120,
          valueFormatter: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        }, {
          headerName: this.$t('FileHistory.fileDownload'),
          cellRenderer: (params) => {
            const self = this
            const eDiv = document.createElement('div')
            let msg = ''
            if (params.data.pdfUrl && params.data.pdfFileId) {
              msg += '<button class="btnDownload" style="margin-left: 20px;">PDF</button>'
            }
            if (params.data.xmlUrl) {
              msg += '<button class="btnDownloadXml" style="margin-left: 20px;">XML</button>'
            }
            eDiv.innerHTML = msg
            if (params.data.pdfUrl && params.data.pdfFileId) {
              const btnDownload = eDiv.querySelectorAll('.btnDownload')[0]
              btnDownload.addEventListener('click', function() { self.downElectronicInvoiceHandler(params.data) })
            }
            if (params.data.xmlUrl) {
              const btnDownloadXml = eDiv.querySelectorAll('.btnDownloadXml')[0]
              btnDownloadXml.addEventListener('click', function() { self.btnDownloadXmlHandler(params.data) })
            }
            return eDiv
          },
          filter: false,
          filterParams: {},
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_TypeOfInvoice'),
          field: 'invoiceTypeCode',
          colId: 'invoiceTypeCode',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.invoicePoolTypeCodeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvoiceType'),
          field: 'invoiceType',
          colId: 'invoiceType',
          width: 100,
          valueFormatter: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.INVOICE_POOL_INVOICE_TYPES)
          }
        }, {
          headerName: this.$t('SeaExport.DateModified'),
          field: 'updateTime',
          colId: 'updateTime',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      selectedRow: null,
      selectedRows: [],
      gridApi: null,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      customSearchItems: [],
      receiptInvoiceTitles: [],
      collectionAssociationChargeDialog: {
        visible: false,
        searchItemModule: '5045',
        addChargeCondition: { // 点击加入费用按钮时传递的参数
          exceptKeys: [],
          isAr: 0,
          hasInvoice: 0,
          oversea: -1,
          commission: 0,
          advance: 0,
          isNeedInvoice: 1,
          shared: 0,
          accountId: 0
        }
      },
      properties: {
        // mode: 0, // 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
        isHedge: false, // 是否对冲
        isAr: false, // 是否应收
        makeInvoiceMethod: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        makeInvoiceMethodHedge: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        typeGroup: 'multi', // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票
        invoiceType: 0, // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
        groupingMakeType: 1, // 发票种类：0=纸质发票、1=电子发票

        currencyGroup: 0, // 分币种开票：0=拆分币种开票、1=合并币种
        cbAssignCurrency: true, // 指定发票币种
        groupingCurrencyType: 0, // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
        currency: 'RMB', // 币种

        showChargeDetail: false, // 是否显示费用明细
        useDefaultRate: false, // 按财务汇率开票
        isInvoicingByBillingRate: false, // 按账单汇率
        billingRateMap: {}, // 账单币种、账单汇率
        makeCostInvoice: false, // 生成成本发票
        billPreInvoicing: false, // 根据账单开票要求开票
        isGenCostInvoice: false, // 是否生成成本发票: isAr ? makeCostInvoice : false
        costInvoiceProp: {},
        defaultContent: false, // 将本次内容设置为默认开票信息

        invoiceGoodsName: {}, // 发票项目名称
        settleDepartment: 0, // 结算部门
        settleDepartmentPrefix: '', // 结算部门归属工作号

        otherCurrencys: [], // 其它币种
        otherRates: [], // 其它币种汇率
        txtCurrency1: '',
        txtRate1: '',
        txtCurrency2: '',
        txtRate2: '',
        rateCache: {}, // 对比发票币种的汇率
        cbAlwarysUseRate: false, // 一直按该汇率开票

        branchId: this.$store.getters.currentOfficeId, // 分公司 Session.getInstance().getOfficeId()
        inputByDep: this.$store.getters.currentDeptId, // 部门 Session.getInstance().currentDepartment.departmentId

        titleMap: {}, // 获取账单所对应的结算单位: getTitleMap()
        invoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(entities)
        hedgeInvoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(hedgeEntities)

        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        entities: [], // 开票实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        allCharges: [],
        chargeMap: {},
        invoices: [], // 生成发票列表
        invoice: {}, // 当前发票
        currentPage: 1, // 顺序号
        totalPage: 0, // 发票总数
        invoiceGoodsNameList: [], // 发票项目名称列表
        invoiceItemGoodsName: 0, // InvoiceItemGoodsName：开票发票项目默认货物或应税劳务名称
        defaultGoodsName: '', // InvoiceMergeName：合并开票费用名称
        receivedRadio: 'ALL', // 对冲开票，应收列表币种：全部/RMB/USD
        paymentRadio: 'ALL', // 对冲开票，应付列表币种：全部/RMB/USD
        showChargeDetailByInvoice: false, // ShowChargeDetailByInvoice：增值发票是否可以显示明细
        invoiceNoEditable: false, // InvoiceSearchEdit: 开票查询修改发票号
        costInfo: false, // costSplitInfo: 是否开启费用拆分金额校验
        isInvoicingByBusinessDateRate: false, // 按业务日期汇率收票
        useAutoCheckInvoicing: false, // 是否使用了自动勾选开票
        autoCheckInvoicingAmount: 0.00, // 自动勾选最大金额
        autoCheckInvoiceAmountEnable: false, // 自动勾选最大金额是否可用
        specificConstraintType: '', // 特定约束类型
        settlementCenterMode: false, // 锦昶共享中心
        isInvoicingByTaxRate: false, // 按税点分组开票
        rbgShowChargeDetail: '' // 显示明细
      },
      getInvoiceTitlesByOfficeCache: new ApiCacheManage(getInvoiceTitlesByOffice) // getInvoiceTitlesByOffice缓存管理
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler(newVal) {
        this.initData()
      }
    }
  },
  async created() {
    await this.initData()
    setTimeout(() => {
      this.$refs.searchItem.advSearch()
    }, 500)
  },
  methods: {
    async initData() {
      this.customSearchItems = []
      // 获取发票抬头列表
      await this.getInvoiceTitlesByOfficeCache.execute({ officeId: this.$store.getters.currentOfficeId }).then(res => {
        this.receiptInvoiceTitles = res.data
      })
      // 初始化 高级查询
      // 购方 名称
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'invoicePool.PAYER_NAME'
      searchField.itemLabel = this.$t('CargoMsg.Cargo_BuyerName')
      searchField.tagName = 'invoiceTitle'
      searchField.tagValue = 'invoiceTitle'
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.dataProvider = this.receiptInvoiceTitles
      searchField.filterType = 'global'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$PAYER_NAME'
      this.customSearchItems.push(searchField.formatObj2Json())

      // 购方 税号
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'invoicePool.PAYER_TAX_NO'
      searchField.itemLabel = this.$t('CargoMsg.Cargo_BuyerTaxNumber')
      searchField.tagName = 'taxAccount'
      searchField.tagValue = 'taxAccount'
      searchField.defaultSelected = 1
      searchField.dataProvider = this.receiptInvoiceTitles
      searchField.filterType = 'global'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$PAYER_TAX_NO'
      this.customSearchItems.push(searchField.formatObj2Json())

      // 销方 名称
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'invoicePool.SELLER_TAX_NAME'
      searchField.itemLabel = this.$t('CargoMsg.Cargo_SellerName')
      searchField.tagName = 'invoiceTitle'
      searchField.tagValue = 'invoiceTitle'
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.defaultValue = this.sellerTaxNameDefaultValue
      this.customSearchItems.push(searchField.formatObj2Json())

      // 是否绑定发票
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_IS_NOT_NULL'
      searchField.itemName = 'invoicePool.INVOICE_UUID'
      searchField.itemLabel = this.$t('CargoMsg.Cargo_BoundInvoiceOrNot')
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = this.isDialog
      searchField.defaultValue = this.isDialog ? false : ''
      this.customSearchItems.push(searchField.formatObj2Json())

      // 有发票附件（是=池上pdfFileId/pdfUrl/backupUrl任一非空；收票关联弹框锁定"是"：文件未同步的票选了也拿不到票面PDF）
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_IS_NOT_NULL'
      searchField.itemName = 'invoicePool.HAS_ATTACHMENT'
      searchField.itemLabel = this.$t('Clearing.InvoicePool_OnlyWithAttachment')
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = this.defaultHasAttachment
      searchField.defaultValue = this.defaultHasAttachment ? true : ''
      this.customSearchItems.push(searchField.formatObj2Json())

      // 发票种类
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'invoicePool.INVOICE_TYPE_CODE'
      searchField.itemLabel = 'CargoMsg.Cargo_TypeOfInvoice'
      searchField.tagName = 'invoiceTypeCode'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.defaultValue = []
      searchField.itemValue = []
      searchField.dataProvider = Array.from(SystemConstants.INVOICE_POOL_INVOICE_TYPE_CODES)
      this.customSearchItems.push(searchField.formatObj2Json())

      this.initConfig()
    },
    // 配置参数
    async initConfig() {
      this.properties.invoiceItemGoodsName = Number(cache.config.get('InvoiceItemGoodsName'))
      this.properties.defaultGoodsName = String(cache.config.get('InvoiceMergeName'))
      this.properties.showChargeDetailByInvoice = String(cache.config.get('ShowChargeDetailByInvoice')) === '1'
      this.properties.invoiceNoEditable = String(cache.config.get('InvoiceSearchEdit')) === '1'
      this.properties.costInfo = Number(cache.config.get('costSplitInfo')) === 1
      this.properties.enableCustomizeRevokeInvoice = Number(cache.config.get('enableCustomizeRevokeInvoice')) === 1
      this.properties.interfaceName = String(cache.config.get('TaxControlInterfaceName'))
      this.properties.interfaceNameEI = String(cache.config.get('EITaxControlInterfaceName'))
      this.properties.terminalSn = String(cache.config.get('baiWangOriginTerminalSN'))
      this.properties.storageURL = String(cache.config.get('StorageURL'))
      this.properties.isInvoiceByEachBillingRate = Number(cache.config.get('isInvoiceByEachBillingRate')) === 1
      this.properties.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.properties.toExoSystemHC = String(cache.config.get('ToExoSystem')) === 'HC' // 海创
      this.properties.QdWarning = String(cache.config.get('QdWarning')) !== '0' // 全电接口-国税应急方案
      this.properties.FeiByAuth = Number(cache.config.get('FeiByAuth')) === 1 // 全电接口是否走实人认证
      this.properties.settlementCenterMode = String(cache.config.get('SettlementCenterMode')) === '1' // 锦昶共享中心
      this.properties.isEasyInoivceVietnam = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_EASY_INOIVCE_VIETNAM // 杰贝越南税控
      this.properties.isBillPreInvoicing = String(cache.config.get('BillingNoteContainInvoiceReques')) // 太平账单预开发票
    },
    getInvoice() {
      this.loading = getLoading4Cxt()
      callInvoicePoolJob({ tenantId: this.$store.getters.tenantId }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 收票关联
    collectionAssociation() {
      if (!this.selectedRows || this.selectedRows.length === 0 || this.selectedRows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.collectionAssociationChargeDialog.visible = true
    },
    async addChargeCallBack(charges) {
      const selectedRow = this.selectedRows[0]
      if (!charges || charges.length === 0) {
        return
      }
      const localCurrency = RateUtil.localCurrencyByOffice()
      this.properties.selectedEntities = charges
      let total = 0
      for (const item of this.properties.selectedEntities) {
        const index = 1
        if (item.currency === localCurrency) {
          total += NumberUtils.ToFixed2(multiply(item.amount, index), 2)
        } else {
          total += NumberUtils.ToFixed2(multiply(item.localAmount, index), 2)
        }
        total = NumberUtils.ToFixed2(total, 2)
      }
      if (Math.abs(NumberUtils.ToFixed2(selectedRow.totalAmount - total, 2)) > 0.01) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TOEIAADFIA'))
        return false
      }
      await this.initMakeInvoice()
      await this.initEntities()
      this.toGenerateInvoiceFaster()
    },
    toGenerateInvoiceFaster() {
      const selectedRow = this.selectedRows[0]
      const allCharges = []
      const chargeMap = {}
      console.log('this.properties.entities', this.properties.entities)
      for (const item of this.properties.entities) {
        const charges = []
        if (this.properties.isGenCostInvoice && item.isOversea && !item.isReceivable) {
          continue
        }
        if (item['entity'] === 'charge' || item.entity === undefined) {
          allCharges.push(item)
          charges.push(item.uuid)
          chargeMap['charge-' + item.uuid] = charges
        }
      }
      if (allCharges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OFNBFSWWF'))
        return
      }
      this.properties.allCharges = allCharges
      this.properties.chargeMap = chargeMap

      if (this.properties && this.properties.invoiceGoodsNameList) {
        this.properties.invoiceGoodsNameList = []
      }
      this.properties.isFei = this.properties && this.properties.groupingMakeType === 1 && (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_AISINO_EI || this.properties.toExoSystemYGSH)
      const requestBody = { 'chargeMap': this.properties.chargeMap, 'properties': this.properties, 'invoicePoolUuid': selectedRow.uuid, 'location': this.location }
      const loading = getLoading4Cxt(this.$refs.dialog)
      generateInvoiceForPool(requestBody).then(res => {
        this.properties.invoices = res.data
        this.selectedRows = []
        this.selectedRow = null
        this.$message.warning(this.$t('CargoMsg.Cargo_OperationComplete'))
        this.collectionAssociationChargeDialog.visible = false
        this.queryHandler()
      }).finally(() => {
        loading.close()
      })
    },
    async initMakeInvoice() {
      this.properties.makeInvoiceMethod = 1
      this.properties.branchId = this.$store.getters.currentOfficeId // 分公司
      this.properties.inputByDep = this.$store.getters.currentDeptId // 部门
      this.properties.isHedge = false
      this.properties.typeGroup = 'multi' // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票
      this.properties.currencyGroup = 1 // 分币种开票：0=拆分币种开票、1=合并币种
      this.properties.cbAssignCurrency = true // 指定发票币种
      this.properties.groupingCurrencyType = 0 // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
      this.properties.currency = RateUtil.localCurrencyByOffice() || 'RMB' // 币种
      this.properties.showChargeDetail = false // 是否显示费用明细
      this.properties.useDefaultRate = false // 按财务汇率开票
      this.properties.isInvoicingByBillingRate = false // 按账单汇率
      this.properties.billingRateMap = {} // 账单币种、账单汇率
      this.properties.makeCostInvoice = false // 生成成本发票
      this.properties.isGenCostInvoice = false // 是否生成成本发票: isAr ? makeCostInvoice : false
      this.properties.costInvoiceProp = {}
      this.properties.defaultContent = false // 将本次内容设置为默认开票信息
      this.properties.invoiceGoodsName = {} // 发票项目名称
      this.properties.settleDepartment = 0 // 结算部门
      this.properties.settleDepartmentPrefix = '' // 结算部门归属工作号
      this.properties.otherCurrencys = [] // 其它币种
      this.properties.otherRates = [] // 其它币种汇率
      this.properties.txtCurrency1 = ''
      this.properties.txtRate1 = ''
      this.properties.txtCurrency2 = ''
      this.properties.txtRate2 = ''
      this.properties.rateCache = {} // 对比发票币种的汇率
      this.properties.cbAlwarysUseRate = false // 一直按该汇率开票
      this.properties.isInvoicingByBusinessDateRate = false // 按业务日期汇率收票
      this.properties.isInvoicingByTaxRate = false // 按税点分组开票
      this.properties.autoCheckInvoiceAmountEnable = false
      this.properties.autoCheckInvoicingAmount = this.properties.groupingMakeType === 1 ? Number(cache.config.get('E-InvoiceMaxAmount')) : Number(cache.config.get('InvoiceMaxAmount'))
      // 加载发票种类、发票类型
      this.initMakeInvoiceType()
    },
    async initMakeInvoiceType() {
      const selectedRow = this.selectedRows[0]
      this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT.code // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
      this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_ELECTRONIC_INVOICE.code // 发票种类：0=纸质发票、1=电子发票
      //  p:普通发票(电子) c:普通发票(纸质) s:专用发票(纸质) b:专用发票(电子) e:收购发票(电子) f:收购发票(纸质) r:普通发票(卷式) t:增值税电子通行费发票 j:机动车销售统一发票 u二手车发票
      //  bs-电子发票（增值税专用发票），pc-电子发票（增值税普通发票），hk数电票（航空）,tl(数电铁路票)，dj:数电机动车发票(电子) ，sj:数电机动车发票(纸质)，du:数电二手车发票(电子) ，su:数电二手车发票(纸质)
      if (selectedRow.invoiceLine === 'p') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_ELECTRONIC_INVOICE.code
      } else if (selectedRow.invoiceLine === 'c') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_PAPER_INVOICE.code
      } else if (selectedRow.invoiceLine === 's') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT_DEDICATED.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_PAPER_INVOICE.code
      } else if (selectedRow.invoiceLine === 'b') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT_DEDICATED.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_ELECTRONIC_INVOICE.code
      } else if (selectedRow.invoiceLine === 'bs') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT_FEI.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_ELECTRONIC_INVOICE.code
      } else if (selectedRow.invoiceLine === 'pc') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_ELECTRONIC_INVOICE.code
      }
    },
    async initEntities() {
      this.properties.entities = []
      const keys = []
      if (this.properties.selectedEntities.length === 0) {
        return
      }
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单
      for (const item of this.properties.selectedEntities) {
        keys.push(item.uuid)
      }
      if (keys.length === 0) return
      const requestBody = { 'keys': keys }
      this.loading = getLoading()
      await getNotInvoiceCharges(requestBody).then(res => {
        this.properties.entities = res.data
      }).finally(() => {
        this.loading.close()
      })
      if (this.properties.entities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoneAnyBillable'))
        return
      }
      this.properties.allEntities = []
      this.properties.allEntities.push(...this.properties.entities)
      //
      this.properties.invoiceGoodsNameList = []
      this.loading = getLoading()
      await queryInvoiceGoodsName({ 'officeId': this.$store.getters.currentOfficeId }).then(res => {
        this.properties.invoiceGoodsNameList = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    deletes() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const invoicePoolUuids = this.selectedRows.map(p => p.uuid)
      this.loading = getLoading4Cxt()
      deleteInvoicePool({ invoicePoolUuids }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        this.queryHandler()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 下载电子发票 pdf
    downElectronicInvoiceHandler(invoicePool) {
      const url = URL.common.findByFileId + '/' + invoicePool.pdfFileId + '?sessionId=' + getToken()
      window.open(url)
    },
    // 下载电子发票 Xml
    btnDownloadXmlHandler(invoicePool) {
      window.open(invoicePool.xmlUrl)
    },
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },
    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryInvoicePool(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.el-form{
  /deep/ .el-input__inner{
    width: 300px;
  }
}
</style>
